<template>
  <v-container v-if="personal">
    <v-form v-model="contactoForm" ref="contacto">
      <v-row>
        <v-col cols="8">
          <div class="text-h6 font-weight-bold">Correo electrónico</div>
        </v-col>
        <v-col cols="4">
          <v-row>
            <v-col cols="12">
              <BaseInput v-model="personal.Contacto.correoElectronico" :rules="emailRules" :readonly="false">
                <template v-slot:label>Correo electrónico</template>
              </BaseInput>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-divider></v-divider>
        </v-col>
        <v-col cols="8">
          <div class="text-h6 font-weight-bold">Teléfonos</div>
        </v-col>
        <v-col cols="4">
          <v-row>
            <v-col cols="12">
              <BaseInput
                v-model="personal.Contacto.telefonoCelular"
                v-mask="'###-###-##-##'"
                type="tel"
                label="Telefono celular"
                maxlength="13"
                :rules="personal.Contacto.telefonoCelular.length > 0 ? phoneRules : []"
              >
                <template #label>Teléfono celular</template>
              </BaseInput>
              <BaseInput
                v-model="personal.Contacto.telefonoFijo"
                v-mask="'###-###-##-##'"
                type="tel"
                label="Telefono fijo"
                maxlength="13"
                :rules="personal.Contacto.telefonoFijo.length > 0 ? phoneRules : []"
              ></BaseInput>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import BaseInput from '../../../base/BaseInput.vue'
import { PERFILES } from '@/perfiles.js'

export default {
  components: {
    BaseInput,
  },
  data() {
    return {
      PERFILES,
      contactoForm: false,
      emailRules: [(v) => !v || /.+@.+\..+/.test(v) || 'El correo electrónico debe ser válido'],
      phoneRules: [(v) => !v || /^\d{3}-\d{3}-\d{2}-\d{2}$/.test(v) || 'El número de teléfono debe ser válido'],
    }
  },
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
    ...mapGetters({
      perfil: 'getPerfil',
    }),
  },
  methods: {
    ...mapActions('personal', ['updatePersonal']),
  },
}
</script>
